import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {NgxCurrencyConfig, NgxCurrencyInputMode} from 'ngx-currency';

@Component({
    selector: 'app-question-label-amount-parent',
    templateUrl: './question-label-amount-parent.component.html',
    styleUrls: ['./question-label-amount-parent.component.scss'],
    standalone: false
})
export class QuestionLabelAmountParentComponent implements OnInit, AfterViewInit {

  @Input() question: Question;
  @Input() showTotal = false;
  @Output() questionAnswer = new EventEmitter<any>();

  questions: Question[] = [];
  maskOptions: NgxCurrencyConfig;

  constructor(private globalQuestionService: GlobalQuestionService) {
  }

  ngOnInit(): void {
    if (this.question) {
      this.globalQuestionService.getChildrenQuestions(this.question?.cent_aq_question_id)
        .subscribe(questions => {
          
          questions.forEach(q => {
            this.questions.push(Object.assign({}, q));
          });
        });
    }
  }

  ngAfterViewInit(): void {
    this.maskOptions = {
      max: null,
      min: null,
      allowZero: true,
      nullable: false,
      inputMode: NgxCurrencyInputMode.Financial,
      align: 'left',
      allowNegative: false,
      prefix: 'R ',
      decimal: '.',
      suffix: '',
      thousands: ' ',
      precision: 0
    };
  }

  get totalAmount(): number {
    let total = 0;
    for (const a of this.questions) {
      total += +a.answer;
    }
    return total;
  }

  saveValue(): void {
    console.log(this.question)
    if (this.question && this.questions.every(q => q.answer)) {
      this.globalQuestionService.saveParentChildren(this.questions)
        .subscribe(r => {
          console.log('here in expected change');
          const value = this.questions.map(i => i.answer).join('|');
          this.question.answer = value;
          this.questionAnswer.emit(this.question);
        });
    }
  }

}
